import { Component, inject, signal } from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { ApprovalService } from '../../core/services/approval.service';
import { QueueItem, QueueState } from '../../core/models/transaction.model';
import { StatusBadge } from '../../shared/components/status-badge';
import { ApprovalApiError } from '../../core/errors/approval-api-error';

const QUEUE_STATES: QueueState[] = [
  'PENDING_APPROVAL',
  'APPROVED_PROCESSING',
  'IN_PROGRESS',
  'SUCCESS',
  'REJECTED',
  'FAILED',
  'REVERSED',
  'HOLD_ERROR',
];

@Component({
  selector: 'app-queue-list',
  imports: [
    MatTableModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    FormsModule,
    StatusBadge,
    DatePipe,
    CurrencyPipe,
  ],
  templateUrl: './queue-list.html',
  styleUrl: './queue-list.scss',
})
export class QueueList {
  private readonly approvalService = inject(ApprovalService);
  private readonly router = inject(Router);

  readonly states = QUEUE_STATES;
  readonly selectedState = signal<QueueState>('PENDING_APPROVAL');
  readonly limit = signal(50);
  readonly items = signal<QueueItem[]>([]);
  readonly loading = signal(false);
  readonly errorMessage = signal<string | null>(null);

  readonly columns = [
    'control_reference',
    'amount',
    'trigger_reason',
    'state',
    'created_at',
  ];

  constructor() {
    this.refresh();
  }

  refresh(): void {
    this.loading.set(true);
    this.errorMessage.set(null);

    this.approvalService.getQueue(this.selectedState(), this.limit()).subscribe({
      next: (items) => {
        this.loading.set(false);
        this.items.set(items);
      },
      error: (err: unknown) => {
        this.loading.set(false);
        this.errorMessage.set(
          err instanceof ApprovalApiError ? err.message : 'Could not load the queue.',
        );
      },
    });
  }

  open(item: QueueItem): void {
    this.router.navigate(['/transactions', item.control_reference]);
  }
}
